import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import propTypes from 'prop-types';
import shortid from 'shortid';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import { createFetch } from '../../../utils';
import lang from '../../../lang';
const { URL_PREFIX } = window;


class ProfileForm extends React.Component {
    constructor() {
        super();
        this.state = {
            isNew: true,
            loading: false,
            errorMessage: {},
            form: {
                profileItems: [],
            },
            indexChanged: [],
            availableProfile: {},
            expandData: [],
        };
        this.cancel = this.cancel.bind(this);
        this.changeFormValue = this.changeFormValue.bind(this);
        this.getAvailableProfile = this.getAvailableProfile.bind(this);
        this.printRowProfile = this.printRowProfile.bind(this);
        this.toggleRow = this.toggleRow.bind(this);
        this.toggleProfileItem = this.toggleProfileItem.bind(this);
        this.save = this.save.bind(this);
    }

    async componentWillMount() {
        const { id } = this.props.match.params;
        const request = [this.getAvailableProfile()];
        if (shortid.isValid(id)) {
            this.setState({ isNew: false });
            request.push(this.getProfileQuery(id));
        } else {
            request.push(this.getAvailableProfile(true));
        }
        try {
            await Promise.all(request);
        } catch (error) {
            Swal.fire({
                title: lang.titleError,
                text: error.message,
                type: 'error',
            });
        }
    }

    async getProfileQuery(id) {
        const { user } = this.props;
        const profileDetail = await createFetch({
            path: `users/profile/detail/${id}`,
            accessToken: user.accessToken,
            method: 'GET',
        });
        if ([400, 403].indexOf(profileDetail.status) > -1) {
            throw new Error(profileDetail.message);
        }
        this.setState({ form: profileDetail.record });
    }

    async getAvailableProfile(isFlat = false) {
        const { user } = this.props;
        const profileItems = await createFetch({
            path: `users/profile/available?isFlat=${isFlat.toString()}`,
            accessToken: user.accessToken,
            method: 'GET',
        });
        if (isFlat) {
            this.setState({
                form: {
                    ...this.state.form,
                    profileItems: profileItems.records.map(o => ({
                        uniqueName: o.uniqueName,
                        readAccess: false,
                        writeAccess: false,
                        label: o.label,
                    })),
                },
            });
        } else {
            this.setState({ availableProfile: profileItems.records });
        }
    }

    changeFormValue(e) {
        const { form } = this.state;
        form[e.target.name] = e.target.value;
        this.setState({ form });
    }

    cancel(e) {
        e.preventDefault();
        // if (this.props.history.length > 2) this.props.history.goBack();
        this.props.history.push(`${URL_PREFIX}/app/profile`);
    }

    toggleRow(uniqueName) {
        const { expandData } = this.state;
        if (expandData.indexOf(uniqueName) > -1) {
            expandData.splice(expandData.indexOf(uniqueName), 1);
        } else {
            expandData.push(uniqueName);
        }

        this.setState({ expandData });
    }

    toggleProfileItem(uniqueName, type = 'readAccess', label = '') {
        const { form, indexChanged } = this.state;
        const index = form.profileItems.findIndex(a => a.uniqueName === uniqueName);
        const data = {
            uniqueName,
            readAccess: true,
            writeAccess: type === 'writeAccess',
            label,
        };
        if (index === -1) {
            form.profileItems.push(data);
            if (indexChanged.indexOf(indexChanged.length) === -1) indexChanged.push(form.profileItems.length);
        } else {
            form.profileItems[index][type] = !form.profileItems[index][type];
            if (indexChanged.indexOf(index) === -1) indexChanged.push(index);
            form.profileItems.forEach((o, index2) => {
                if (o.uniqueName.includes(uniqueName)) {
                    if (indexChanged.indexOf(index2) === -1) indexChanged.push(index2);
                    form.profileItems[index2][type] = form.profileItems[index][type];
                    if (type === 'writeAccess') form.profileItems[index2].readAccess = form.profileItems[index].writeAccess;
                }
            });
        }
        this.setState({ form, indexChanged });
    }

    printRowProfile(root = [], deep = 1, parentName = '', withWriteAccess = false) {
        const { expandData } = this.state;
        const { profileItems } = this.state.form;
        if (root.length === 0) return null;
        let profiles = [];
        let writeTd = null;
        if (expandData.indexOf(parentName) === -1 && deep > 1) return [];
        root.sort((a, b) => {
            if (a.label < b.label) return -1;
            if (a.label > b.label) return 1;
            return 0;
        }).forEach((profileItem) => {
            const currentValue = profileItems.find(a => a.uniqueName === profileItem.uniqueName);
            if (withWriteAccess) {
                writeTd = (
                    <td style={{ width: '20%' }}>
                        <input
                            type="checkbox"
                            name={profileItem.label}
                            value={profileItem.uniqueName}
                            checked={currentValue && currentValue.writeAccess}
                            onChange={e => this.toggleProfileItem(e.target.value, 'writeAccess', e.target.name)}
                        />
                    </td>
                );
            }
            profiles.push(
                <tr className="" id={profileItem.uniqueName} data-depth={deep}>
                    <td style={{ paddingLeft: (deep - 1) * 30 }} className="flex">
                        {
                            profileItem.child && profileItem.child.length > 0 ? (
                                <a href={null} className="expand-btn" onClick={() => this.toggleRow(profileItem.uniqueName)}>
                                    <i className={`fa fa-${expandData.indexOf(profileItem.uniqueName) > -1 ? 'minus' : 'plus'}`} />
                                </a>)
                                : null
                        }
                        <p>
                            {profileItem.label}
                        </p>
                    </td>
                    <td style={{ width: '20%' }}>
                        <input
                            type="checkbox"
                            name={profileItem.uniqueName}
                            value={profileItem.uniqueName}
                            checked={currentValue && currentValue.readAccess}
                            onChange={e => this.toggleProfileItem(e.target.name, 'readAccess')}
                        />
                    </td>
                    {writeTd}
                </tr>,
            );
            profiles = profiles.concat(this.printRowProfile(profileItem.child, deep + 1, profileItem.uniqueName, withWriteAccess));
        });
        return profiles;
    }

    async save() {
        if (this.state.loading) return;
        this.setState({ loading: true });
        try {
            const { isNew, form, indexChanged } = this.state;
            const { accessToken } = this.props.user;
            const item = indexChanged.map(o => form.profileItems[o]);
            const result = await createFetch({
                path: 'users/profile',
                method: isNew ? 'POST' : 'PATCH',
                body: {
                    ...form,
                    profileItems: item.filter(o => o !== null && o !== undefined),
                },
                accessToken,
            });
            
            if (result.status === 200) {
                Swal.fire({
                    title: lang.common.success,
                    text: lang.profile.successProfileSaved,
                    type: 'success',
                });
                if (isNew) this.props.history.push(`${URL_PREFIX}/app/profile/${result.id}`);
                this.setState({ loading: false });
                return;
            }
            throw new Error(lang.common.incomplete);
        } catch (error) {
            this.setState({ loading: false });
            Swal.fire({
                title: lang.titleError,
                text: error.message,
                type: 'error',
            });
        }
    }

    render() {
        const {
            isNew, loading, errorMessage, form, availableProfile,
        } = this.state;
        return (
            <div className="row content" id="profileForm">
                <div className="header-section">
                    <Link to={`${URL_PREFIX}/app/profile`} className="" onClick={this.cancel}>
                        <i className="fa fa-arrow-left" /> Back
                    </Link>
                    <h2>{lang.common[isNew ? 'new' : 'edit']} Profile</h2>
                    <div className="flex col-sm-6 col-offset-sm-3 col-lg-4 action-btn">
                        <button className="btn btn-alternate" onClick={this.save}>{lang.common.save}</button>
                        <button className="btn btn-default" onClick={this.cancel}>{lang.common.cancel}</button>
                    </div>
                </div>
                <div className="clearfix" />
                <p className="text-center">
                    {loading ? <i className="fa fa-circle-notch fa-spin fa-4x loading" /> : null}
                </p>
                <div className="col-lg-12">
                    <div className="row flex" style={{ backgroundColor: '#fff', padding: 10 }}>
                        <div className="form">
                            <div className="group">
                                <p>{lang.profile.columnName.name}</p>
                                <input type="text" className="form-control" value={form.name} name="name" onChange={this.changeFormValue} />
                                {errorMessage.name ? <p className="error-message">{errorMessage.name}</p> : null}
                            
                            </div>
                            <div className="group">
                                <p>{lang.profile.columnName.description}</p>
                                <textarea type="text" className="form-control" value={form.description} name="description" onChange={this.changeFormValue} rows={10} />
                                {errorMessage.description ? <p className="error-message">{errorMessage.description}</p> : null}
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-stripped">
                                <thead>
                                    <tr>
                                        <th>Profile Item</th>
                                        <th>{lang.common.visible}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.printRowProfile(availableProfile[0] ? availableProfile[0].child : [])}
                                </tbody>
                            </table>
                            <table className="table table-stripped">
                                <thead>
                                    <tr>
                                        <th>Object Access</th>
                                        <th>{lang.common.readOnly}</th>
                                        <th>{lang.common.editable}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.printRowProfile(availableProfile[1] ? availableProfile[1].child : [], 1, '', true)}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


ProfileForm.propTypes = {
    history: propTypes.object.isRequired,
    match: propTypes.object.isRequired,
    user: propTypes.object.isRequired,
};

const mapDispatchToProps = dispatch => (
    bindActionCreators({
    }, dispatch)
);

const mapStateToProps = state => ({
    user: state.user,
});


export default connect(mapStateToProps, mapDispatchToProps)(ProfileForm);
